import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import { getToken } from "./services/managerToken";
import Menu from "./components/menu/Menu";
import Home from "./pages/home/Home";
import Cadastro from "~/pages/cadastro/Cadastro";
import Avaliacao from "~/pages/avaliacao/Avaliacao";
import CardioVascular from "~/pages/cardiovascular/CardioVascular";
import Recordatorio from "~/pages/recordatorio/Recordatorio";
import Questionario from "~/pages/questionario/Questionario";
import QualidadeVida from "~/pages/qualidadeVida/QualidadeVida";
import Agendamento from "~/pages/agendamento/agendamento";
import AgendamentoTreinamento from "./pages/agendamentoTreinamento/agendamentoTreinamento";
//Pages Login
import Login from "./pages/auth/login";
import ConfirmaAgendamento from "./pages/confirmaAgendamento/confirmaAgendamento";
import ConfirmaConsultaWhats from "./pages/confirmaConsultaWhats/confirmaConsultaWhats";
// import NotAuth from "./pages/auth/notAuth";
// import TokenInvalido from "./pages/auth/tokenInvalido";

// const PrivateRoute = ( { component: Component, ...rest } ) => {
//     return (
//         <Route { ...rest } render={ props => {
//             const token = getToken();
//             if ( token ) {
//                 if ( rest.auth ) {
//                     if ( token.includes( rest.auth ) )
//                         return <Component { ...props } />;
//                     return (
//                         <Redirect
//                             to={ {
//                                 pathname: "/notAuth",
//                                 state: { from: props.location }
//                             } }
//                         />
//                     );
//                 }
//                 return <Component { ...props } />;
//             } else {
//                 return (
//                     <Redirect
//                         to={ {
//                             pathname: "/tokenInvalido",
//                             state: { from: props.location }
//                         } }
//                     />
//                 );
//             }
//         } }
//         />
//     );
// };

export default (props) => {
    return (
        <Switch>
            <Route path="/" exact component={Login} />
            {/* <Route path='/notAuth' component={ NotAuth } />
            <Route path='/tokenInvalido' component={ TokenInvalido } /> */}

            <Menu>
                <Route path="/home" component={Home} />
                <Route path="/cadastro" component={Cadastro} />
                <Route path="/avaliacao" component={Avaliacao} />
                <Route path="/cardioVascular" component={CardioVascular} />
                <Route path="/recordatorio" component={Recordatorio} />
                <Route path="/questionario" component={Questionario} />
                <Route path="/qualidadeVida" component={QualidadeVida} />
                <Route path="/agendamento" component={Agendamento} />
                <Route
                    path="/agendamentoTreinamento"
                    component={AgendamentoTreinamento}
                />
                <Route
                    path="/confirma"
                    component={ConfirmaAgendamento}
                />
                <Route
                    path="/confirmaWhats"
                    component={ConfirmaConsultaWhats}
                />
            </Menu>
        </Switch>
    );
};
